skrilla.controller('promotionClaimDetailsCtrl', function ($scope, searchService, cacheService, $stateParams, srefService) {

    searchService.get("promotions/claims/" + $stateParams.id).then(function(response){
        $scope.claim = response.data;
    });


    $scope.routeOwner = function(){
        var location = $scope.claim.ownerType === "USER" ? "userDetails" : "affiliateDetails";
        srefService.go(location, {id: $scope.claim.ownerId});
    }

});